var script_loaded = false;

function loadJSscripts() {
  if (script_loaded) return;
  script_loaded = true;

  // solta o trabalho pesado do handler de interação para o próximo frame
  requestAnimationFrame(function () {
    observer.disconnect();

    document.querySelectorAll("iframe.lazy").forEach(function (t) {
      var datasrc = t.dataset.src;
      if (datasrc != null) t.src = datasrc;
    });

    var scripts = document.getElementsByTagName("script");
    for (var i = 0; i < scripts.length; i++) {
      if (scripts[i].getAttribute("data-src") !== null) {
        scripts[i].setAttribute("src", scripts[i].getAttribute("data-src"));
        delete scripts[i].dataset.src;
      }
      if (scripts[i].getAttribute("type") === "text/lazyload") {
        var newScript = document.createElement("script");
        for (var a = 0; a < scripts[i].attributes.length; a++) {
          var attr = scripts[i].attributes[a];
          newScript.setAttribute(attr.name, attr.value);
        }
        newScript.type = "text/javascript";
        newScript.innerHTML = scripts[i].innerHTML;
        scripts[i].parentNode.replaceChild(newScript, scripts[i]);
      }
    }

    var links = document.getElementsByTagName("link");
    for (var j = 0; j < links.length; j++) {
      if (links[j].getAttribute("data-href") !== null) {
        links[j].setAttribute("href", links[j].getAttribute("data-href"));
        delete links[j].dataset.href;
      }
    }

    document.dispatchEvent(new CustomEvent("asyncLazyLoad"));
  });
}

var activityEvents = ["mousedown", "mousemove", "keydown", "scroll", "touchstart", "click", "keypress", "touchmove"];
activityEvents.forEach(function (evt) {
  // passive: não bloqueia scroll/touch enquanto o handler roda
  // once: remove o listener sozinho após disparar 1x (hoje eles nunca são removidos)
  window.addEventListener(evt, loadJSscripts, { passive: true, once: true });
});